<template lang='pug'>
div.block( :id='`block-${name}`' )
  span(v-html="html" v-translate)
</template>

<script setup lang="ts">
import { onMounted, onServerPrefetch, ref } from 'vue'
import { useRogue } from '../services/Rogue'

const props = defineProps({
  name: {
    required : true,
    type     : String,
    default  : null,
  },
})

const html = ref<string>('')

const rogue = useRogue()

async function init() {
  try {
    const res = await rogue.api.fetch({
      url   : `/svc_content/cms/block/${props.name}`,
      cache : { key: `block-${props.name}`, seconds: 60 * 60 },
    })

    if (res.active && res.content) {
      html.value = res.content
    }
  } catch (e) {
    rogue.log.warn(`Could not load block ${e.message}`)
  }
}

onServerPrefetch(async () => {
  await init()
})

onMounted(() => {
  init()
})
</script>

<style lang='scss' scoped>
.block {
  overflow: hidden;
}
</style>
